export const enviroment = {
    PRODUCTION: false,
    MOCKUP: false,
    BASE_URL_API: 'https://hml-api.ftpilot.com',
    BASE_URL_FILES: 'https://hml-api.ftpilot.com',
    BASE_URL: 'https://hml.ftpilot.com',
    BASE_URL_API_IMAGE_VCU: 'https://hml.ftpilot.com/ft_models',
    BASE_URL_CDN_MEDIA: 'https://hml-cdn-media.ftpilot.com/',
    BASE_URL_SSE: 'https://sse-hml.ftpilot.com',
    COGNITO_OAUTH_URL: 'https://oauth-hml.fueltech.cloud',
    COGNITO_CLIENT_ID: '2prllsvrio0h3tc719sgc23hck',
    REQUIRE_APPROVAL: true,
    HLS_PLAYBACK: true,
}

